<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="newrequestlist">
          <div class="container-fluid h-100 p-0">
            <div class="newrequestlist__topcontent newrequestlist__wrapper">
              <div class="dynamic-component-keep-alive-demo clearfix">
                <div class="button-group p-0">
                  <div class="row m-0">
                    <button class="newrequestlist__topcontent--tabs"
                      :class="{ 'newrequestlist__topcontent--selected':
                      selectedtabs === tab.router}"
                      v-for="tab in tabs" :key="tab.id" @click="changeTab(tab.router)">
                      <p class="text-center">{{ tab.title }}</p>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="selectedtabs !== 'instant-quote' && tabActiveFailed !== 'Instant-Quote'" class="row m-0 newrequestlist__topcontent--filter">
                <div class="d-flex align-items-center pr-2">
                  <span>Filter By</span>
                </div>
                <div class="options__multiselect d-flex align-items-center">
                  <multiselect
                    v-model="selected"
                    :options="filterOptions"
                    placeholder="Select"
                    selectedLabel=""
                    @input="filterChoice"
                    label="text"
                    :select-label="''" :deselect-label="''"
                    >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                </div>
                <div class="pr-0 ml-3 options__multiselect d-flex align-items-center"
                v-if="isDropdown(selected.text)">
                  <multiselect
                    v-model="selectedText"
                    :options="getDropdownData(selected.text)"
                    placeholder="Select"
                    label="text"
                    selectedLabel=""
                    :select-label="''" :deselect-label="''"
                    @input="chooseFilterDropdown"
                    >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                </div>
                <div class="d-flex align-items-center">
                  <b-input class="ml-3" v-if="isShowInput(selected.text)"
                  :placeholder="`Input ${selected.text}`"
                  v-model="searchItem" @input="debouncedOnChange()">
                  </b-input>
                  <b-input placeholder="Date" class="choose-date ml-3" v-if="selected.text == 'Expired Date'"
                    :type="type1" @focus="type1 = 'date'"
                    v-model="searchItem" @input="debouncedOnChange()">
                  </b-input>
                  <div class="row m-0 ml-3" v-if="selected.text == 'Created Date'">
                    <b-input placeholder="From" class="choose-date"
                    :max="getDate(dateTo || new Date())"
                      :type="type1" @focus="type1 = 'date'"
                      v-model="dateFrom" @input="checkCreatedDate()"></b-input>
                    <div class="px-2 pt-1">-</div>
                    <b-input placeholder="To" class="choose-date" :max="getDate(new Date())"
                      :min="getDate(dateFrom)" :type="type2" @focus="type2 = 'date'"
                      v-model="dateTo"  @input="checkCreatedDate()"></b-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="paginationCustom">
              <div class="newrequestlist__wrapper pt-3 pb-2 showing_entries">
                <div class="row m-0 tabfailed mb-1" v-if="selectedtabs === 'failed' || selectedtabs === 'complete'">
                  <button class="mr-3" :class="{'button_active' : tabActiveFailed === item.value}"
                  v-for="(item, i) in secondaryTabs" :key="i" @click="changeSecondaryTabs(item.value)">{{item.text}}</button>
                </div>
                <div class="row m-0 justify-content-between align-items-center" v-if="requestList.length > 0 ">
                  <div>Showing {{listFrom}} to {{listTo}} of {{totalRows}} entries</div>
                  <div class="row m-0 align-items-center">
                    <span class="pr-3">Rows per page</span>
                    <div class="options__dropdown">
                      <b-dropdown>
                        <template slot="button-content">
                          <p>{{perPage}}</p>
                        </template>
                        <b-dropdown-item @click="choosePerPage(item.value)"
                        v-for="(item,i) in optionsRow" :key="i">
                          <span> {{item.value}} </span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="selectedtabs !== 'failed' && selectedtabs !== 'complete' ? 'newrequestlist__mastercontent' : 'newrequestlist__mastercontent2'">
              <List
              :requestList="requestList"
              :selectedtabs="selectedtabs"
              :tabActiveFailed="tabActiveFailed"
              />
            </div>
            <div class="row m-0 paginationCustom pt-3" v-if="requestList.length > 0">
              <div class="col-md-12 d-flex justify-content-center">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last">
                </b-pagination>
              </div>
            </div>
          </div>
        </div>  <!-- end class = managementshipment -->
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import List from '@/components/requestList/List.vue'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import moment from 'moment'
// eslint-disable-next-line import/no-cycle
import mixin from '@/mixin'

export default {
  name: 'Requestlist',
  components: {
    Sidebar,
    List
  },
  mixins: [mixin],
  data () {
    return {
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      selectedtabs: 'rfq',
      tabActiveFailed: 'RFQ',
      requestList: [],
      tabs: [
        {
          id: 1,
          title: 'RFQ List',
          router: 'rfq'
        },
        {
          id: 2,
          title: 'Contract List',
          router: 'contract'
        },
        {
          id: 3,
          title: 'Instant Quote',
          router: 'instant-quote'
        },
        {
          id: 4,
          title: 'Completed',
          router: 'complete'
        },
        {
          id: 5,
          title: 'Failed',
          router: 'failed'
        }
      ],
      secondaryTabs: [
        { text: 'RFQ', value: 'RFQ' },
        { text: 'Contract', value: 'Contract' },
        { text: 'Instant Quote', value: 'Instant-Quote' }
      ],
      optionsRow: [
        { value: 10 },
        { value: 20 },
        { value: 30 }
      ],
      filterOptions: [
        { text: 'All', value: 'All' },
        { text: 'RFQ Number', value: 'number' },
        { text: 'Status Bid', value: 'status-bid' },
        { text: 'Shipment Type', value: 'shipment-type' },
        { text: 'Expired Date', value: 'expired-date' },
        { text: 'Created Date', value: 'created-date' }
      ],
      statusRFQOptions: [
        { text: 'All', value: 'All' },
        { text: 'Waiting for Bid', value: 'waiting-bid' },
        { text: 'Quotation Available', value: 'bid-submitted' },
        { text: 'Validating', value: 'validating' }
      ],
      statusContractOptions: [
        { text: 'All', value: 'All' },
        { text: 'Waiting for Bid', value: 'waiting-bid' },
        { text: 'Quotation Available', value: 'bid-submitted' },
        { text: 'Validating', value: 'validating' },
        { text: 'On Going', value: 'ongoing' }
      ],
      statusFailedOptions: [
        { text: 'All', value: 'All' },
        { text: 'Rejected', value: 'rejected' },
        { text: 'Canceled', value: 'cancel' }
      ],
      shipmentOptions: [
        { text: 'All', value: 'all' },
        { text: 'Land', value: 'LAND' },
        { text: 'Air Cargo', value: 'AIRCARGO' },
        { text: 'Air Courier', value: 'AIRCOURIER' },
        { text: 'Air Breakbulk', value: 'AIRBREAKBULK' },
        { text: 'LCL', value: 'SEALCL' },
        { text: 'FCL', value: 'SEAFCL' },
        { text: 'Ocean Breakbulk', value: 'SEABREAKBULK' },
        { text: 'LCT', value: 'LCT' },
        { text: 'Barge', value: 'BARGE' },
      ],
      filter: {
        page: 1,
        type: 'ongoing',
        filter: '',
        key: ''
      },
      selectedText: {
        text: 'All',
        value: ''
      },
      selected: {
        text: 'All',
        value: ''
      },
      searchItem: '',
      inputText: '',
      dateFrom: '',
      dateTo: '',
      type1: 'text',
      type2: 'text',
      isFiltering: false,
      listFrom: 0,
      listTo: 0
    }
  },
  computed: {
    debouncedOnChange () {
      return _.debounce(this.onChange, 700)
    },
    ...mapGetters({
      isLoadingIq: 'instantQuote/isLoading',
      iqItems: 'instantQuote/items',
      errorIq: 'instantQuote/error',

      iqFilter: 'instant/QuoterfqFilter',
      errorIqFilter: 'instant/QuoteerrorRfqFilter',
      isLoadingIqFilter: 'instant/QuoteisLoadingRfqFilter',

      isLoadingRfq: 'rfq/isLoading',
      rfqItems: 'rfq/items',
      errorRfq: 'rfq/error',

      rfqFilter: 'rfq/rfqFilter',
      errorRfqFilter: 'rfq/errorRfqFilter',
      isLoadingRfqFilter: 'rfq/isLoadingRfqFilter',

      isLoadingContract: 'contract/isLoading',
      contractItems: 'contract/items',
      errorContract: 'contract/error',

      contractFilter: 'contract/contractFilter',
      errorContractFilter: 'contract/errorContractFilter',
      isLoadingContractFilter: 'contract/isLoadingContractFilter'

    })
  },
  async mounted () {
    await this.checkTabs(this.$route.params.type)
    await this.checkTabsFailed(this.$route.params.failedType)
    if (!_.isEmpty(this.$route.query)) {
      this.watchQuery(this.$route.query)
    } else {
      this.fetchRequestList()
    }
  },
  methods: {
    routeToFilter () {
      const ongoingParams = { type: this.isFiltering ? this.selectedtabs : this.$route.query.type }
      const nonOngoingParams = { type: this.isFiltering ? this.selectedtabs : this.$route.query.type, failedType: this.tabActiveFailed }
      this.$router.push({
        name: 'RequestList',
        params: this.selectedtabs === 'rfq' || this.selectedtabs === 'contract' || this.selectedtabs === 'instant-quote' ? ongoingParams : nonOngoingParams,
        query: {
          page: this.isFiltering ? this.filter.page : this.$route.query.page,
          type: this.isFiltering ? this.selectedtabs : this.$route.query.type,
          filter: this.isFiltering ? this.filter.filter : this.$route.query.filter,
          key: this.isFiltering ? this.filter.key : this.$route.query.key
        }
      })
    },
    onChange () {
      if (this.searchItem.includes('/')) {
        this.inputText = this.searchItem.split('/').join('-')
        this.filter.key = this.searchItem.split('/').join('-')
      } else {
        this.inputText = this.searchItem
        this.filter.key = this.searchItem
      }
    },
    checkCreatedDate () {
      if (this.dateFrom && this.dateTo && !this.isFiltering) {
        this.filter.key = `${this.dateFrom},${this.dateTo}`
        this.isFiltering = true
      } else if (this.dateFrom && this.dateTo && this.isFiltering) {
        this.filter.key = `${this.dateFrom},${this.dateTo}`
        this.routeToFilter()
      }
    },
    getDate (date) {
      let newDate = ''
      if (date) {
        newDate = moment(date).format('YYYY-MM-DD')
      }
      return newDate
    },
    routeToNonFilter () {
      if (this.selectedtabs === 'rfq' || this.selectedtabs === 'contract' || this.selectedtabs === 'instant-quote') {
        this.$router.push({ name: 'RequestList', params: { type: this.selectedtabs } })
      } else {
        this.$router.push({ name: 'RequestList', params: { type: this.selectedtabs, failedType: this.tabActiveFailed } })
      }
    },
    changeTab (item) {
      if ((this.$route.query && this.$route.query.type !== item) || (this.$route.params.type !== item)) {
        this.filterChoice()
        this.currentPage = 1
        this.selectedtabs = item
        // set default filteroption
        // failed & completed punya tab lagi di dalamnya
        if (item === 'failed' || item === 'complete') {
          this.filterOptions[1].text = 'RFQ Number'
          this.tabActiveFailed = 'RFQ'
        } else {
          this.filterOptions[1].text = item === 'rfq' ? 'RFQ Number' : 'Contract Number'
          this.tabActiveFailed = ''
        }
        this.routeToNonFilter()
      }
    },
    sumShowing (data) {
      const { length } = data.data
      this.listFrom = ((this.currentPage - 1) * this.perPage) + 1
      this.listTo = (this.listFrom - 1) + length
    },
    chooseFilterDropdown () {
      this.filter.key = this.selectedText.value
      this.filter.page = 1
      if (this.selectedText.value === 'All') {
        this.isFiltering = false
      } else if (this.isFiltering) {
        this.routeToFilter()
      } else {
        this.isFiltering = true
      }
    },
    filterChoice () {
      this.filter.filter = this.selected.value
      this.selectedText = { text: 'All', value: 'All' }
      this.searchItem = ''
      this.filter.key = ''
      this.type1 = 'text'
      this.type2 = 'text'
      this.dateFrom = ''
      this.dateTo = ''
      this.inputText = ''
      this.isFiltering = false
    },
    isDropdown (type) {
      let condition = false
      if (type === 'Shipment Type' || type === 'Status Bid') {
        condition = true
      }
      return condition
    },
    getDropdownData (type) {
      let data = []
      if (type === 'Shipment Type') {
        data = this.shipmentOptions
      } else if (this.selectedtabs === 'rfq') {
        data = this.statusRFQOptions
      } else if (this.selectedtabs === 'contract') {
        data = this.statusContractOptions
      } else if (this.selectedtabs === 'failed') {
        data = this.statusFailedOptions
      }
      return data
    },
    async fetchRequestList () {
      const { currentPage } = this
      const { perPage } = this
      if (this.selectedtabs === 'rfq') {
        await this.$store.dispatch('rfq/FETCH_RFQ', {
          type: 'ongoing', currentPage, perPage
        })
      } else if (this.selectedtabs === 'contract') {
        await this.$store.dispatch('contract/FETCH_CONTRACT', {
          type: 'ongoing', currentPage, perPage
        })
      } else if (this.selectedtabs === 'instant-quote') {
        await this.$store.dispatch('instantQuote/FETCH_IQ', {
          page: currentPage, filter: 'ONGOING', itemPerPage: perPage
        })
      } else if (this.selectedtabs === 'failed' && this.tabActiveFailed === 'RFQ') {
        await this.$store.dispatch('rfq/FETCH_RFQ', {
          type: 'failed', currentPage, perPage
        })
      } else if (this.selectedtabs === 'failed' && this.tabActiveFailed === 'Contract') {
        await this.$store.dispatch('contract/FETCH_CONTRACT', {
          type: 'failed', currentPage, perPage
        })
      } else if (this.selectedtabs === 'failed' && this.tabActiveFailed === 'Instant-Quote') {
        await this.$store.dispatch('instantQuote/FETCH_IQ', {
          page: currentPage, filter: 'FAILED', itemPerPage: perPage
        })
      } else if (this.selectedtabs === 'complete' && this.tabActiveFailed === 'RFQ') {
        await this.$store.dispatch('rfq/FETCH_RFQ', {
          type: 'complete', currentPage, perPage
        })
      } else if (this.selectedtabs === 'complete' && this.tabActiveFailed === 'Contract') {
        await this.$store.dispatch('contract/FETCH_CONTRACT', {
          type: 'complete', currentPage, perPage
        })
      } else if (this.selectedtabs === 'complete' && this.tabActiveFailed === 'Instant-Quote') {
        await this.$store.dispatch('instantQuote/FETCH_IQ', {
          page: currentPage, filter: 'COMPLETED', itemPerPage: perPage
        })
      }
    },
    async fetchRequestListFilter () {
      const type = this.selectedtabs
      if (type === 'rfq') {
        await this.$store.dispatch('rfq/FETCH_RFQ_FILTER', { payload: this.filter, perPage: this.perPage })
      } else if (type === 'contract') {
        await this.$store.dispatch('contract/FETCH_CONTRACT_FILTER', { payload: this.filter, perPage: this.perPage })
      } else if (type === 'failed') {
        this.filter.type = 'failed'
        if (this.tabActiveFailed === 'RFQ') {
          await this.$store.dispatch('rfq/FETCH_RFQ_FILTER', { payload: this.filter, perPage: this.perPage })
        } else {
          await this.$store.dispatch('contract/FETCH_CONTRACT_FILTER', { payload: this.filter, perPage: this.perPage })
        }
      } else {
        this.filter.type = 'complete'
        if (this.tabActiveFailed === 'RFQ') {
          await this.$store.dispatch('rfq/FETCH_RFQ_FILTER', { payload: this.filter, perPage: this.perPage })
        } else if (this.tabActiveFailed === 'Contract') {
          await this.$store.dispatch('contract/FETCH_CONTRACT_FILTER', { payload: this.filter, perPage: this.perPage })
        } else {
          await this.$store.dispatch('contract/FETCH_CONTRACT_FILTER', { payload: this.filter, perPage: this.perPage })
        }
      }
    },
    isShowInput (item) {
      let isShow = false
      if (item === 'RFQ Number' || item === 'Contract Number') {
        isShow = true
      }
      return isShow
    },
    choosePerPage (item) {
      this.perPage = item
      if (this.isFiltering) {
        this.fetchRequestListFilter()
      } else {
        this.fetchRequestList()
      }
    },
    changeSecondaryTabs (item) {
      if (this.tabActiveFailed !== item) {
        this.tabActiveFailed = item
        this.filterOptions[1].text = item === 'RFQ' ? 'RFQ Number' : 'Contract Number'
        this.routeToNonFilter()
      }
    },
    checkTabs (type) {
      this.selectedtabs = type
      this.filter.type = type !== 'rfq' && type !== 'contract' ? type : 'ongoing'
    },
    checkTabsFailed (type) {
      if (type) {
        this.tabActiveFailed = type
      }
    },
    watchQuery (data) {
      this.filter.page = data.page
      this.filter.type = data.type
      this.filter.filter = data.filter
      this.checkTabs(data.type)
      this.filter.key = data.key
      this.currentPage = data.page
      const filterType = this.filterOptions.filter(item => item.value === data.filter)
      if (filterType) {
        this.selected.text = filterType[0].text
        this.selected.value = filterType[0].value
      }
      if (this.isDropdown(this.selected.text)) {
        const filterSubType = this.getDropdownData(this.selected.text).filter(
          item => item.value === data.key
        )
        this.selectedText.text = filterSubType[0].text
        this.selectedText.value = filterSubType[0].value
      } else if (data.filter === 'created-date') {
        const filterSubType = data.key.split(',')
        // eslint-disable-next-line prefer-destructuring
        this.dateFrom = filterSubType[0]
        // eslint-disable-next-line prefer-destructuring
        this.dateTo = filterSubType[1]
      } else {
        this.searchItem = data.key
        this.inputText = data.key
      }
      this.isFiltering = true
      this.fetchRequestListFilter()
    }
  },
  watch: {
    '$route.params.type': function (type) {
      this.checkTabs(type)
    },
    '$route.params.failedType': function (type) {
      this.checkTabsFailed(type)
    },
    '$route.query': function (data) {
      if (!_.isEmpty(data)) {
        this.watchQuery(data)
      } else {
        this.selectedText = { text: 'All', value: 'All' }
        this.searchItem = ''
        this.filter.key = ''
        this.inputText = ''
        this.type1 = 'text'
        this.type2 = 'text'
        this.dateFrom = ''
        this.dateTo = ''
        this.isFiltering = false
        this.fetchRequestList()
      }
    },
    rfqItems (data) {
      if (data && !this.isFiltering) {
        this.totalRows = data.totalRecord
        this.requestList = data.data
        this.sumShowing(data)
      }
    },
    contractItems (data) {
      if (data && !this.isFiltering) {
        this.totalRows = data.totalRecord
        this.requestList = data.data
        this.sumShowing(data)
      }
    },
    iqItems (data) {
      if (data && !this.isFiltering) {
        this.totalRows = data.totalRecord
        this.requestList = data.data
        this.sumShowing(data)
      }
    },
    rfqFilter (data) {
      if (data && this.isFiltering) {
        this.totalRows = data.totalRecord
        this.requestList = data.data
        this.sumShowing(data)
      }
    },
    contractFilter (data) {
      if (data && this.isFiltering) {
        this.totalRows = data.totalRecord
        this.requestList = data.data
        this.sumShowing(data)
      }
    },
    currentPage (data) {
      if (!this.isFiltering) {
        this.fetchRequestList()
      } else if (this.isFiltering) {
        this.filter.page = data
        this.routeToFilter()
      }
    },
    inputText (data) {
      if (data && !this.isFiltering) {
        this.isFiltering = true
      } else if (data && this.isFiltering) {
        this.routeToFilter()
      } else {
        this.isFiltering = false
      }
    },
    isFiltering (data) {
      if (data) {
        this.routeToFilter()
      } else {
        this.currentPage = 1
        this.filter.page = 1
        this.routeToNonFilter()
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/view/requestList/index.vue